// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5785":"818a61fd","6797":"1f6d1322","8688":"c979e12a","8864":"d4c32a44"}[chunkId] + ".chunk.css";
};